import React from "react";

interface ChatTypingIndicatorProps {
  className?: string;
}

export const ChatTypingIndicator: React.FC<ChatTypingIndicatorProps> = ({
  className = ""
}) => {
  return (
    <div className={`chat-typing-indicator ${className}`}>
      <div className="chat-typing-indicator__dot" />
      <div className="chat-typing-indicator__dot" />
      <div className="chat-typing-indicator__dot" />
    </div>
  );
};
